import { Box, Collapse, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import {
  getModuleNameInArea,
  // getModulesInArea,
  getPatientReferrals,
  getPatientTrainFrom,
  inquiryPatient,
  setPatientTrainFrom,
} from "./api/area";
import CalendarIcon from "./assets/SVG/calendarIcon";
import ClockIcon from "./assets/SVG/clockIcon";
import DownArrow from "./assets/SVG/downArrow";
import MedicalRecordsIcon from "./assets/SVG/medicalRecordsIcon";
import ProfilePatientIcon from "./assets/SVG/profilePatientIcon";
import Qarbal from "./components/areaManager/parvandeh/qarbal/qarbal";
import Referral from "./components/areaManager/parvandeh/referral";
import DrugInParvande from "./components/areaManager/sidebarArea/drug/drugInParvande";
import CustomizedHook from "./components/project/autocomplatePro";
import { InputCreateProject } from "./components/project/createProjectPop";
import { CheckBoxBranch } from "./components/signin/chekboxListBranch";
import ErjaParvandeh from "./pages/leaderGroup/erjaParvandeh";
import TableQarbalParvande from "./tableQarbalParvande";

export function LabelParvandeh({ label, value }) {
  return (
    <Box width="calc(100% - 20px )">
      <Typography fontWeight={"bold"}>{label}</Typography>
      <Box
        border="solid 1px #D0D0D0"
        color="#3A3939"
        p="10px"
        borderRadius="10px"
        width="100%"
        fontSize="14px"
      >
        {value}
      </Box>
    </Box>
  );
}

export default function Parvandeh() {
  const [data, setData] = useState();
  const [CollapseQarbal, setCollapseQarbal] = useState();
  const [dataQarbalTable, setDataQarbalTable] = useState([]);
  const [moduleInArea, setModuleInArea] = useState();
  const [selectedModule, setSelectedModule] = useState("amozesh");
  const [moduleErja, setModuleErja] = useState();
  const [dataQarbal, setDataQarbal] = useState({
    height: "",
    weight: "",
    // shepesh: "",
    recvCulturePackage: false,
    recvShampoo: false,
    description: "",
    bmi: "",
  });
  

  useEffect(() => {
    inquiryPatient(window.location.search.split("?", 3)[1].split("&", 3)[0], {
      identifier: window.location.search.split("?", 3)[1].split("&", 3)[1],
      identifierType: window.location.search.split("?", 3)[1].split("&", 3)[2],
    })
      .then((x) => {
        setData(x);
      })
      .catch(() => {});
    // setSelectedModule(decodeURIComponent(window.location.search.split("?", 3)[1].split("&", 5)[4]))
  }, []);
  // console.log(decodeURIComponent(window.location.search.split("?", 3)[1].split("&", 5)[4]),);
  // console.log(window.location.search.split("?", 3)[1].split("&", 5));
  // useEffect(() => {
  //   if (data?.id) {
  //     getPatientReferrals(
  //       window.location.search.split("?", 3)[1].split("&", 3)[0],
  //       data?.id
  //     )
  //       .then((x) => console.log(x))
  //       .catch(() => {});
  //   }
  // }, [data]);
  // useEffect(() => {
  //   console.log(window.location.search.split("?", 3)[1].split("&", 5)[4]);
  // });

  useEffect(() => {
    if (dataQarbal?.weight && dataQarbal?.height) {
      setDataQarbal({
        ...dataQarbal,
        bmi: parseInt(
          dataQarbal?.weight /
            ((dataQarbal?.height * dataQarbal?.height) / 10000)
        ),
      });
    }
  }, [dataQarbal?.weight, dataQarbal?.height]);

  useEffect(() => {
    getPatientTrainFrom(
      window.location.search.split("?", 3)[1].split("&", 3)[0],
      window.location.search.split("?", 3)[1].split("&", 4)[3]
    )
      .then((x) => setDataQarbalTable([x]))
      .catch(() => {});
    setSelectedModule(
      decodeURIComponent(window.location.search.split("&", 5)[4])
    );
  }, []);
  // console.log(decodeURIComponent(window.location.search.split("&", 5)[4]));

  useEffect(() => {
    // if (data) {
    // getModulesInArea(window.location.search.split("?", 3)[1].split("&", 3)[0])
    //   .then((x) => setModuleErja(x))
    //   .catch(() => {});
    getModuleNameInArea(
      window.location.search.split("?", 3)[1].split("&", 3)[0]
    )
      .then((x) => setModuleInArea(x))
      .catch(() => {});
    setSelectedModule(
      decodeURIComponent(
        window.location.search.split("?", 3)[1].split("&", 5)[4]
      )
    );
    // }
  }, []);
  // console.log(window.location.search.split("?", 3)[1].split("&", 3)[0]);

  return (
    <>
      <Box p="20px">
        <Box
          bgcolor="white"
          width="calc(100vw - 40px )"
          height="calc(100vh - 40px )"
          borderRadius="17px"
          display="flex"
          sx={{ overflow: "hidden" }}
        >
          <Box
            sx={{
              overflow: "auto",
              "::-webkit-scrollbar": {
                display: "none",
              },
            }}
            width="calc(25% - 20px)"
            py="20px"
          >
            <Box
              display="flex"
              pb="20px"
              borderBottom={"solid 3px #D6DAFF"}
              justifyContent={"center"}
              alignItems="center"
            >
              <Box width={"fit-content"}>
                <Box
                  p="20px"
                  borderRadius="50%"
                  border="solid 2px var(--emr-darkblue)"
                >
                  <ProfilePatientIcon />
                </Box>
                <Box
                  mt="20px"
                  color="#E2445C"
                >{`شماره پرونده : ${data?.patientNo}`}</Box>
              </Box>
            </Box>
            <Box display="grid" gap="20px" justifyContent={"center"} py="20px">
              <Box
                display="flex"
                bgcolor="#42C3CF"
                p="10px"
                height="30px"
                color="white"
                borderRadius="11px"
                alignItems={"center"}
              >
                <MedicalRecordsIcon size="0.4" color="white" />
                <Typography>مشاهده پرونده پزشکی</Typography>
              </Box>
              <LabelParvandeh label="نام و نام خانوادگی" value={data?.name} />
              <LabelParvandeh label="نام پدر" value={data?.fatherName} />
              <LabelParvandeh
                label="تاریخ تولد"
                value={data?.birthDate?.split("-", 2)[0]}
              />
              <LabelParvandeh label="کد ملی" value={data?.identifier} />
              <LabelParvandeh
                label={
                  data?.ageType === "ADULT"
                    ? "شماره تلفن "
                    : "شماره تلفن والدین"
                }
                value={data?.phone}
              />
              <LabelParvandeh
                label="نوع بیمه"
                value={
                  data?.insurance === "TAKMIL"
                    ? "تکمیلی"
                    : data?.insurance === "MILITARY"
                    ? "نیروهای مسلح"
                    : data?.insurance === "TAMIN"
                    ? "تامین اجتماعی"
                    : data?.insurance === "SALAMAT"
                    ? "سلامت"
                    : "ندارد "
                }
              />
            </Box>
          </Box>
          <Box
            width="150px"
            borderRight="solid 3px #D6DAFF"
            borderLeft="solid 3px #D6DAFF"
            sx={{
              overflow: "auto",
              "::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <Box display={"grid"} justifyItems="center">
              <Box
                sx={{ fontFamily: "icomoon !important " }}
                className={"icon-classroom-1"}
                color={"var(--emr-disable)"}
                mt="40px"
                mb="10px"
                fontSize="30px"
              />
              <Typography
                width="100%"
                textAlign="center"
                color={
                  selectedModule === "amozesh"
                    ? "var(--emr-darkblue)"
                    : "#909090"
                }
                fontWeight="bold"
                // mt="40px"
                fontSize="20px"
                onClick={() => setSelectedModule("amozesh")}
                sx={{ cursor: "pointer" }}
              >
                آموزش
              </Typography>
            </Box>
            {moduleInArea &&
              Object.entries(moduleInArea)?.map((x) => (
                <Box display={"grid"} justifyItems="center">
                  <Box
                    sx={{ fontFamily: "icomoon !important " }}
                    className={x[1]}
                    color={"var(--emr-disable)"}
                    mt="40px"
                    mb="10px"
                    fontSize="30px"
                  />
                  <Typography
                    width="100%"
                    textAlign="center"
                    color={
                      selectedModule === x[0]
                        ? "var(--emr-darkblue)"
                        : "#909090"
                    }
                    fontWeight="bold"
                    fontSize="20px"
                    sx={{ cursor: "pointer" }}
                    onClick={() => setSelectedModule(x[0])}
                  >
                    {x[0]}
                  </Typography>
                </Box>
              ))}
            <Box display={"grid"} justifyItems="center">
              <Box
                sx={{ fontFamily: "icomoon !important " }}
                className={"icon-pharmacy"}
                color={"var(--emr-disable)"}
                mt="40px"
                mb="10px"
                fontSize="30px"
              />
              <Typography
                width="100%"
                textAlign="center"
                color={
                  selectedModule === "drug" ? "var(--emr-darkblue)" : "#909090"
                }
                fontWeight="bold"
                // mt="40px"
                fontSize="20px"
                onClick={() => setSelectedModule("drug")}
                sx={{ cursor: "pointer" }}
              >
                داروخانه
              </Typography>
            </Box>
            <Box display={"grid"} justifyItems="center">
              <Box
                sx={{ fontFamily: "icomoon !important " }}
                className={"icon-pharmacy"}
                color={"var(--emr-disable)"}
                mt="40px"
                mb="10px"
                fontSize="30px"
              />
              <Typography
                width="100%"
                textAlign="center"
                color={
                  selectedModule === "erja" ? "var(--emr-darkblue)" : "#909090"
                }
                fontWeight="bold"
                // mt="40px"
                fontSize="20px"
                onClick={() => setSelectedModule("erja")}
                sx={{ cursor: "pointer" }}
              >
                ارجاع
              </Typography>
            </Box>
          </Box>
          <Box width="calc(60% - 40px)" px="20px">
            <Box display="flex" p="15px">
              <Box gap="10px" display="flex" alignItems={"center"}>
                <CalendarIcon />
                <Typography>{`تاریخ مراجعه بیمار: ${
                  data?.createdAt?.split("-", 2)[0]
                }`}</Typography>
              </Box>
              <Box mr="20px" gap="10px" display="flex" alignItems={"center"}>
                <ClockIcon />
                <Typography>{`ساعت مراجعه بیمار: ${
                  data?.createdAt?.split("-", 2)[1]
                }`}</Typography>
              </Box>
            </Box>
            {selectedModule === "amozesh" && (
              <Box sx={{ height: "80vh", overflowY: "auto" }}>
                <Typography
                  mt="20px"
                  fontWeight="bold"
                  color="var(--emr-darkblue)"
                >
                  {data?.ageType === "ADULT"
                    ? "آموزش بزرگسالان"
                    : "آموزش کودکان"}
                </Typography>
                <Box
                  onClick={() => setCollapseQarbal(!CollapseQarbal)}
                  bgcolor="#EFF1F7"
                  borderRadius={"7px"}
                  p="10px"
                  display="flex"
                  justifyContent={"space-between"}
                  alignItems="center"
                  mt="20px"
                >
                  <Typography color="var(--emr-darkblue)">
                    {data?.ageType === "ADULT"
                      ? "اطلاعات غربالگری بزرگسالان"
                      : "اطلاعات غربالگری کودکان"}
                  </Typography>
                  <DownArrow transform={CollapseQarbal} />
                </Box>
                <Collapse in={CollapseQarbal} timeout="auto">
                  <Box mt="-5px" bgcolor="#EFF1F7" p="10px">
                    <Box display="flex" flexWrap="wrap" gap="20px">
                      <InputCreateProject
                        placeholder={"اندازه قد بیمار بر حسب سانتی متر"}
                        label="قد"
                        value={dataQarbal?.height}
                        onChange={(e) =>
                          setDataQarbal({
                            ...dataQarbal,
                            height: e.target.value.replace(/\D/g, ""),
                          })
                        }
                      />
                      <InputCreateProject
                        placeholder={"اندازه وزن بیمار بر حسب کیلوگرم"}
                        label="وزن"
                        value={dataQarbal?.weight}
                        onChange={(e) =>
                          setDataQarbal({
                            ...dataQarbal,
                            weight: e.target.value.replace(/\D/g, ""),
                          })
                        }
                      />
                      <InputCreateProject
                        placeholder={"چیزی بنویسید"}
                        label="BMI"
                        value={parseInt(
                          dataQarbal?.weight /
                            ((dataQarbal?.height * dataQarbal?.height) / 10000)
                        )}
                        // onChange={(e) =>
                        //   setDataQarbal({
                        //     ...dataQarbal,
                        //     bmi:parseInt(
                        //       dataQarbal?.weight /
                        //         ((dataQarbal?.length * dataQarbal?.length) / 10000)
                        //     ) ,
                        //   })
                        // }
                      />
                      <Box sx={{ overflow: "hidden" }} width="250px">
                        <CustomizedHook
                          multiple
                          placeholder={"انتخاب کنید."}
                          label="شپش"
                          options={[
                            { title: "normal", name: "NORMAL" },
                            { title: "nit", name: "NIT" },
                            { title: "شپش بالغ", name: "BALEGH" },
                          ]}
                          value={dataQarbal?.shepesh}
                          onChange={(event, newValue) => {
                            setDataQarbal({
                              ...dataQarbal,
                              shepesh: newValue.name,
                            });
                          }}
                        />
                      </Box>
                      <InputCreateProject
                        placeholder={"چیزی بنویسید"}
                        label="توضیحات"
                        value={dataQarbal?.description}
                        onChange={(e) =>
                          setDataQarbal({
                            ...dataQarbal,
                            description: e.target.value,
                          })
                        }
                      />
                      <Box mt="10px">
                        <CheckBoxBranch
                          onChange={(e) =>
                            setDataQarbal({
                              ...dataQarbal,
                              recvCulturePackage: e.target.checked,
                            })
                          }
                          width={"160px"}
                          label="بسته فرهنگی"
                        />
                        <CheckBoxBranch
                          onChange={(e) =>
                            setDataQarbal({
                              ...dataQarbal,
                              recvShampoo: e.target.checked,
                            })
                          }
                          width={"100px"}
                          label="شامپو"
                        />
                      </Box>
                    </Box>
                    <Box mt="10px" display="flex" justifyContent="end">
                      <botton
                        style={{
                          border: "none",
                          backgroundColor: "var(--emr-darkblue)",
                          color: "white",
                          padding: "5px 40px",
                          borderRadius: "10px",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setPatientTrainFrom(
                            window.location.search
                              .split("?", 3)[1]
                              .split("&", 3)[0],
                            data?.id,
                            dataQarbal
                          )
                            .then((x) => {
                              getPatientTrainFrom(
                                window.location.search
                                  .split("?", 3)[1]
                                  .split("&", 3)[0],
                                window.location.search
                                  .split("?", 3)[1]
                                  .split("&", 4)[3]
                              )
                                .then((x) => setDataQarbalTable([x]))
                                .catch(() => {});
                            })
                            .catch(() => {});
                        }}
                      >
                        ثبت
                      </botton>
                    </Box>
                    {dataQarbalTable?.length >= 1 && (
                      <TableQarbalParvande rowData={dataQarbalTable} />
                    )}
                  </Box>
                </Collapse>
                <Referral data={data} />
              </Box>
            )}
            {selectedModule &&
              selectedModule !== "amozesh" &&
              selectedModule !== "drug" &&
              selectedModule !== "erja" && (
                <Qarbal
                  moduleErja={moduleErja}
                  dataUser={data}
                  selectedModule={selectedModule}
                  areaId={
                    window.location.search.split("?", 3)[1].split("&", 3)[0]
                  }
                />
              )}
            {selectedModule === "drug" && (
              <DrugInParvande
                areaId={
                  window.location.search.split("?", 3)[1].split("&", 3)[0]
                }
                parvande
              />
            )}
            {selectedModule === "erja" && (
              <ErjaParvandeh
                areaId={
                  window.location.search.split("?", 3)[1].split("&", 3)[0]
                }
                patientId={
                  window.location.search.split("?", 3)[1].split("&", 4)[3]
                }
                parvande
              />
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
}
